<template>
<div>
  <div v-for="i in program.max_number_of_allowed_groups" :key='i' class="full-width">
    <select v-model="data.areas_of_focus[i - 1]" @change="$emit('areasOfFocusUpdated', i)" class="full-width">
      <option value="" disabled selected>Select Area of Focus</option>
      <option v-for="aof in areas" :key="aof.id" :value="aof.id">{{aof.name}}</option>
    </select>
  </div>
</div>

</template>
<script>
export default {
  props: ["program", "data", "areas"],
}
</script>
